// src/services/api.js - API Service with Batch and Likes

const API_BASE_URL = 'https://unbonlineprojects.ca/idd-apps/idd-image-share/api';

class ApiService {
  
  // Helper method to make API calls
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };
    
    try {
      const response = await fetch(url, { headers, ...options });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error("API Request Error:", error);
      throw error;
    }
  }

  // ==================== CHARACTER METHODS ====================

  async getAllCharacters() {
    return this.request('/characters.php');
  }

  async getCharacter(id) {
    return this.request(`/characters.php/${id}`);
  }

  async createCharacter(characterData) {
    return this.request('/characters.php', {
      method: 'POST',
      body: JSON.stringify(characterData),
    });
  }

  // NEW: Batch Upload
  async createBatchCharacters(charactersArray) {
    return this.request('/characters.php/batch', {
      method: 'POST',
      body: JSON.stringify(charactersArray),
    });
  }

  async updateCharacter(id, characterData) {
    return this.request(`/characters.php/${id}`, {
      method: 'PUT',
      body: JSON.stringify(characterData),
    });
  }

  // NEW: Like Character
  async likeCharacter(id) {
    // Note: Endpoint structure matches PHP logic: /characters.php/{id}/like
    return this.request(`/characters.php/${id}/like`, {
      method: 'PUT'
    });
  }

  async deleteCharacter(id) {
    return this.request(`/characters.php/${id}`, {
      method: 'DELETE',
    });
  }

  // ==================== LOCAL STORAGE FAVORITES ====================

  getFavoriteIds() {
    const stored = localStorage.getItem('favorites');
    return stored ? JSON.parse(stored) : [];
  }

  isFavorite(characterId) {
    const favorites = this.getFavoriteIds();
    return favorites.includes(characterId);
  }

  toggleFavorite(characterId) {
    let favorites = this.getFavoriteIds();
    
    if (favorites.includes(characterId)) {
      // Remove
      favorites = favorites.filter(id => id !== characterId);
    } else {
      // Add
      favorites.push(characterId);
    }

    localStorage.setItem('favorites', JSON.stringify(favorites));
    return favorites;
  }

  async getFavoritesWithDetails() {
    const allCharacters = await this.getAllCharacters();
    const favoriteIds = this.getFavoriteIds();
    return allCharacters.filter(char => favoriteIds.includes(char.id));
  }
}

export default new ApiService();